<app-page-header></app-page-header>
<app-breadcromb pageName="Login"></app-breadcromb>
<!-- Login Area Start -->
<section class="jobguru-login-area section_70">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="login-box">
          <div class="login-title">
            <h3>Sign in</h3>
          </div>
          <form [formGroup]="loginForm" (ngSubmit)="loginUser()">
            <div class="single-login-field">
              <input type="email" formControlName="username" placeholder="Email Address">
              <div *ngIf="submitted && f.username.errors" class="invalid-feedback">
                <div *ngIf="f.username.errors.required">Username is required</div>
              </div>
            </div>
            <div class="single-login-field">
              <input type="password" formControlName="password" placeholder="Password">
              <div *ngIf="submitted && f.username.errors" class="invalid-feedback">
                <div *ngIf="f.username.errors.required">Username is required</div>
              </div>
            </div>
            <div class="remember-row single-login-field clearfix">
              <p class="checkbox remember">
                <input class="checkbox-spin" type="checkbox" id="Freelance">
                <label for="Freelance"><span></span>Keep Me Signed In</label>
              </p>
              <p class="lost-pass">
                <a href="#" routerLink="/forget-password">Forgot password?</a>
              </p>
            </div>
            <div class="single-login-field">
                <button [disabled]="loading" class="btn btn-primary btn-xs" type="submit">
                  <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
                  Sign In
                </button>
              <div *ngIf="error" class="alert alert-danger mt-3 mb-0">{{error}}</div>
            </div>
          </form>
          <div class="dont_have">
            <a href="#" routerLink="/register">Don't have an account?</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- Login Area End -->
